import { ArrowLeft } from 'lucide-react';

const CheckoutHeader = ({ isCustomLinkCheckout, handleBackNavigation, isReactivating, selectedPlan }) => {
  return (
    <div className="flex items-start sm:items-center gap-2.5 sm:gap-3.5 mb-4 sm:mb-6">
      {!isCustomLinkCheckout && (
        <button
          onClick={handleBackNavigation}
          className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 shadow-xs flex items-center justify-center cursor-pointer shrink-0 mt-0.5 sm:mt-0"
          aria-label="Go Back"
        >
          <ArrowLeft size={16} className="text-[#067978] sm:w-[18px] sm:h-[18px]" />
        </button>
      )}
      <div>
        <h1 className="text-lg sm:text-2xl font-black text-[#067978] tracking-tight uppercase">
          {isReactivating ? 'SUBSCRIPTION REACTIVATION' : 'SUBSCRIPTION CHECKOUT'}
        </h1>
        <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
          {isReactivating
            ? `Reactivate your e-mandate for ${selectedPlan?.name || 'Subscription'} Tier.`
            : 'Review your plan details and authorize your subscription e-mandate.'
          }
        </p>
      </div>
    </div>
  );
};

export default CheckoutHeader;
